import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../context/AppContext";
import { LiveTest } from "./cabinet/LiveTest";

// The Test Console as its own page (docs/tasks/35): pick a cabinet, watch its
// cameras with what the review reads on them, open the door, follow the basket.
const KEY = "ainaopen.test_console.device";

export function LiveTestPage() {
  const api = useApi();
  const [devices, setDevices] = useState([]);
  const [deviceId, setDeviceId] = useState(() => { try { return localStorage.getItem(KEY) || ""; } catch { return ""; } });
  useEffect(() => {
    api.listDevices().then((d) => {
      const list = (Array.isArray(d) ? d : d?.data || []).filter((x) => !x.revoked);
      setDevices(list);
      if (!list.some((x) => x.id === deviceId) && list.length) {
        const pick = list.find((x) => x.online && x.hardware !== "emulator") || list[0];
        setDeviceId(pick.id);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);
  useEffect(() => { try { if (deviceId) localStorage.setItem(KEY, deviceId); } catch { /* private window */ } }, [deviceId]);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold">Test console</h1>
          <p className="text-sm text-slate-500">A cabinet's cameras with what the review reads on them, the door, and the current basket, close to real time.</p>
        </div>
        <div className="flex items-end gap-2">
          <label className="text-xs">Cabinet
            <select className="input" value={deviceId} onChange={(e) => setDeviceId(e.target.value)}>
              {devices.map((d) => <option key={d.id} value={d.id}>{d.name || d.id} {d.online ? "● online" : "○ offline"}</option>)}
            </select>
          </label>
          {deviceId && <Link className="btn btn-secondary text-xs" to={`/cabinets/${deviceId}`}>Cabinet page</Link>}
        </div>
      </div>
      {deviceId ? <LiveTest deviceId={deviceId} /> : <p className="text-sm text-slate-500">No cabinet.</p>}
    </div>
  );
}
